module.exports = __webpack_public_path__ + "static/Charter-Regular-b0aa8c930355fc3f890f69b7207a6b07.ttf";